// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {useState, useEffect, useCallback} from 'react';
import {use_request} from '/www/util/pub/react_hooks.js';
import * as api from '../api.js';
import {call_api} from '../util.js';

export {use_request};

export function use_api_fetch(opts={}){
    const {
        method,
        params,
        default_value=null,
        disabled=false,
        no_cleanup=false,
    } = opts;
    const method_fn = api[method];
    const [wrap, etask, {processing}] = use_request();
    const [data, set_data] = useState(default_value);
    if (!method_fn)
        throw new Error(`Method ${method} is not found`);
    useEffect(()=>void etask(function*(){
        if (disabled)
            return;
        if (!no_cleanup)
            set_data(default_value);
        const res = yield wrap(call_api(()=>method_fn(params)));
        if (!res)
            return;
        set_data(res);
    }), [method_fn, params, default_value, disabled, no_cleanup]);
    return {data, set_data, processing};
}

export function use_api_submit(opts={}){
    const {method, on_success} = opts;
    const method_fn = api[method];
    if (!method_fn)
        throw new Error(`Method ${method} is not found`);
    const [wrap, etask, {processing}] = use_request();
    const submit = useCallback(data=>etask(function*(){
        const res = yield wrap(call_api(()=>method_fn(data)));
        if (!res)
            return;
        on_success?.(res);
        return res;
    }), [method_fn, on_success]);
    return {submit, processing};
}
